import { playerDisplayFnFactory } from './bat-tracking-table-helpers'

function getEntityHeaderName(type) {
    if (type.includes('-team')) {
        return 'Team'
    }
    if (type === 'league') {
        return ''
    }

    return 'Player'
}

function getTeamHeaderName(type) {
    if (type.includes('-team')) {
        return ''
    }
    if (type === 'league') {
        return ''
    }

    return 'Team'
}

export default function getDynamicAggregateFirstHeaders(
    type = 'batter',
    playerTabLink = ''
) {
    const isLeague = type === 'league'
    const hiddenTeamClass = isLeague ? 'hidden' : ''

    return [
        {
            name: getEntityHeaderName(type),
            field: 'name',
            headerClass: `th-component-header align-left th-vertical-bottom table-static-column`,
            fieldClass: `tr-data align-left table-static-column`,
            defaultSortDir: 'asc',
            displayFn: playerDisplayFnFactory(playerTabLink),
        },
        {
            name: getTeamHeaderName(type),
            field: 'team_name',
            headerClass: `th-component-header align-center th-vertical-bottom table-static-column ${hiddenTeamClass}`,
            fieldClass: `tr-data align-center table-static-column ${hiddenTeamClass}`,
            defaultSortDir: 'asc',
            displayFn: (_val, { team_id, n_teams, pinned }) => {
                if (n_teams > 1 || isLeague || pinned) {
                    return `<img class="table-team-logo" src="/site-core/images/savant-mlb.svg" onerror="this.onerror='';this.src='/site-core/images/savant-mlb.svg'" />`
                }
                return `<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/${team_id}.svg" onerror="this.onerror='';this.src='/site-core/images/savant-mlb.svg'" />`
            },
        },
    ]
}
